const config = {
    API_BASE_URL: process.env.REACT_APP_API_BASE_URL || "https://snitchier-internationally-enzo.ngrok-free.dev"
};

export default config;
